const props = {
  width: '100%',
  height: '100%',
  autoPlay: true,
  controls: false,
  loop: false
};

export default props;
